export enum ViewBlock {
  Root = 'View',
}

export enum ViewElement {
  TopContent = 'topContent',
}
